import styled, {
  keyframes,
} from 'styled-components';

const flash = keyframes`
  0% {
    background: #fafafa;
  }

  50% {
    background: rgba(23, 43, 77, 0.1);
  }

  100% {
    background: #fafafa;;
  }
`;

export const ListRow = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  border-top: 1px solid ${props => (props.selected ? '#90b9d6' : '#f1f1f1')};
  border-right: 1px solid #f1f1f1;
  box-sizing: border-box;
  padding: 10px;
  cursor: pointer;
  background: ${props => (props.selected ? '#90b9d6' : '#f9f9f9')};
`;

export const ListRowBody = styled.div`
  display: flex;
  flex-flow: row nowrap;
  flex: 0 0 100%;
  width: 100%;
`;

export const Info = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  width: 100%;
  height: 16px;
  color: #333;
  font-size: 14px;
  line-height: 22px;
`;

export const FakeItem = styled.div`
  width: ${props => props.size || 0};
  height: 16px;
  margin-left: ${props => (props.space ? '10px' : 0)};
  background: #f3f3f3;
  animation-name: ${flash};
  animation-delay: ${props => props.delay || '1s'};
  animation-duration: 1s;
  animation-iteration-count: infinite;
`;

export const ItemImg = styled.img`
  width: 16px;
  height: 16px;
  min-width: 16px;
  min-height: 16px;
  transform: translateY(3px);
`;

export const Summary = styled.div`
  color: rgba(0, 0, 0, .7);
  text-overflow: ellipsis;
  overflow: hidden;
  margin-left: 2px;
`;

export const Key = styled.div`
  color: rgba(0, 0, 0, .5);
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 100%;
  margin-left: 10px;
`;

export const Total = styled.div`
  color: rgba(0, 0, 0, .5);
  max-width: 100%;
  overflow: visible;
  margin-left: 10px;
`;

export const AvatarWrap = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  height: 22px;
  margin-right: 8px;
`;
